import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
//import { ToastrService } from 'ngx-toastr';
import { CategoryModel } from 'src/app/shared/models/category.model';
import { ProductModel } from 'src/app/shared/models/product.model';
import { RmaItemExModel, RmaItemModel } from 'src/app/shared/models/rma.model';
import { ProductCategoryService } from 'src/app/shared/services/product-category.service';
import { ProductService } from 'src/app/shared/services/product.service';
import { RmaMasterService } from 'src/app/shared/services/rma-master.service';
import { GlobalNotification} from "src/app/shared/constants/global-notification";

@Component({
  selector: 'app-edit-sr-product-item',
  templateUrl: './edit-sr-product-item.component.html',
  styleUrls: ['./edit-sr-product-item.component.css']
})
export class EditSRProductItemComponent implements OnInit {

  //form : FormGroup = ProductModel.getFormGroup();
  rmaItem : RmaItemModel;
  dialogData :any;
  listProduct : ProductModel[];
  listFindProduct : ProductModel[];
  searchKey : string;
  @ViewChild('searchInput', {static: false}) searchInput :ElementRef;

  //public snArray : string [];

  constructor(
    private service : RmaMasterService,
    //private toastr : ToastrService,
    private gnotify : GlobalNotification,
    private pservice : ProductService,
    private dialogRef: MatDialogRef<EditSRProductItemComponent>,
    @Inject(MAT_DIALOG_DATA) data) {

   console.log("EditSRProductItemComponent");
      this.dialogData = data;
      if(this.dialogData && this.dialogData.rmaitem)
      {
        this.rmaItem = this.dialogData.rmaitem;
      }
      else{
        this.rmaItem  = new RmaItemModel();
      }

   }

  ngOnInit() {
    console.log("ngOnInit");

    this.pservice.getList().subscribe(
      res=>{
        console.log("pservice.getList()");
        this.listProduct = res as ProductModel[];
        if(this.dialogData != null && this.dialogData.rmaitem != null)
        {
          this.listFindProduct = this.listProduct.filter(x => x.productId == this.dialogData.rmaitem.productId);
        }
      },
      err=>{}
      );

  }

  onClose() {

    this.service.form.reset();
    this.service.initializeFormGroup();
    this.dialogRef.close();
  }

  onSubmit() {
    console.log("Create product");


    if (this.isValid()) {
        this.dialogData.rmaitem = this.rmaItem;
        this.dialogData.product = this.listProduct.filter(x => x.productId ==  this.rmaItem.productId)[0];
        this.dialogData.result = true;
        this.onClose();
    }
    else{
      ////this.toastr.error("Failed to Submit", "Invalid request");
      this.gnotify.showSnackBar('Invalid request', 'Failed to Submit', "error");
    }

    /*
    if (this.service.form.valid) {
      //if (!this.service.form.get('rmaItemId').value){ // new
        this.dialogData.rmaitem = this.service.form.value;
        this.dialogData.product = this.listProduct.filter(x => x.productId == this.service.form.value.productId)[0];
        this.dialogData.result = true;
        this.onClose();
      //}
      //else{
      //}
    }
    else{
      this.toastr.error("Failed to Submit", "Invalid request");
    }*/
  }

  isValid()
  {
    if (!this.rmaItem) return false;
    if(!this.rmaItem.productId) return false;
    if(!this.rmaItem.purchaseFrom ||this.rmaItem.purchaseFrom.length < 3 ) return false;
    if(!this.rmaItem.snList || this.rmaItem.snList.length == 0) return false;
    for(var i = 0; i <this.rmaItem.snList.length; i++)
    {
      if(!this.rmaItem.snList[i] || this.rmaItem.snList[i].length < 3) return false;
    }

    return true;
  }


  onKey(data)
  {
    this.searchKey = data;
    if(!data || data.length == 0)
    {
          this.listFindProduct = null;
    }
    else
    {
      var temp = data.toLowerCase();
      this.listFindProduct = this.listProduct.filter(x =>  x.productName.toLowerCase().includes(temp));
    }
  }

  onSearchClear()
  {
    console.log("onSearchClear");
    this.searchInput.nativeElement.value = '';
    this.searchKey = "";
    this.listFindProduct = null;
  }

  onDeleteSN(item)
  {

    var index = this.rmaItem.snList.indexOf(item);
    if (index > -1) {
      this.rmaItem.snList.splice(index, 1);
    }

  }

  trackByFn(index, item) {
    return index;
  }


  onAddSN()
  {
    if(this.rmaItem.snList == null) this.rmaItem.snList = new Array();
    this.rmaItem.snList.push("");
  }

  loadContent(contents) {
  //  var element = document.getElementById('file-content');
  //  element.textContent = contents;
    try{
      this.rmaItem.snList = contents.replace(/\s*/g, "").split(",");
      return;
    }
    catch{
    }

    ////this.toastr.error("Failed to parse the data. Please try again.", "Invalid S/N data");
    this.gnotify.showSnackBar('Invalid S/N data', 'Failed to parse the data. Please try again.', "error");

  }


  onImportFromCVS(file)
  {
      if (!file) {
        return;
      }

      var that = this;

      var singleFile = file[0];
      var reader = new FileReader();

      reader.onload = (function (file) { // here we save variable 'file' in closure
        return function (e) { // return handler function for 'onload' event
            console.log(this.result);
            that.loadContent(this.result);
/*
           try{
            this.snArray = this.result.split(",");
            console.log(this.snArray.length);
            return;
          }
          catch{
          }

          this.toastr.error("Failed to parse the data. Please try again.", "Invalid S/N data");
          */
      }})(file);

      reader.readAsText(singleFile);
  }
}
